export default __webpack_public_path__ + "static/media/unknown.e2ff79ba.svg";